export default "__VITE_ASSET__6c2e14f3__"